/* eslint-disable no-undef */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog, DialogContent, DialogTitle, FormControl, MenuItem, Paper,
  Select,
} from '@material-ui/core';
import MaterialTable from 'material-table';
import { toastError, toastSuccess } from '../../../../redux/actions/alertActions';
import { studentServices } from '../../../../redux/services/studentServices';
import { Loading } from '../../../../helpers/utils';
import evaluoServices from '../../../../redux/services/evaluoServices';

const AddStudent = ({
  open,
  setOpen,
  examData,
  company,
}) => {
  const [student, setStudent] = useState({});
  const [students, setStudents] = useState([]);
  const [studentsInExam, setStudentsInExam] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(true);

  const getStudents = async () => {
    if (company && examData.name) {
      setLoading(true);
      // get semester students + catchUp students OR get company students?
      const resStudents = await evaluoServices.getStudentsInExam(examData.id);
      const res = await studentServices.getStudentsByCompany(company._id);
      const semester = examData.name.match(/\d+/)[0];
      const studentsArr = [];
      const studentsInExamArr = [];
      res.forEach((studentItem) => {
        let found = false;
        if (resStudents && resStudents.length > 0) {
          resStudents.forEach((user) => {
            if (user.user?.email === studentItem.email) {
              found = true;
              studentsInExamArr.push({ ...studentItem, evaluoId: user.user?.id });
            }
          });
        }
        if (studentItem.semester === parseInt(semester, 10)
          || studentItem.catchUp?.includes(parseInt(semester, 10))) {
          if (!found) {
            studentsArr.push(studentItem);
          }
        }
      });
      setStudentsInExam(studentsInExamArr);
      setStudents(studentsArr);
      setLoading(false);
    }
  };

  const addStudentToExam = async () => {
    const res = await evaluoServices.addStudentToEvaluoExam(examData.id, student);
    if (res === 'success') {
      setReload(!reload);
      toastSuccess('Student added successfully');
    } else {
      toastError('Failed to add student');
    }
  };

  const deleteStudentFromExam = async (evaluoId) => {
    const res = await evaluoServices.deleteStudentFromEvaluoExam(examData.id, evaluoId);
    if (res === 'success') {
      setReload(!reload);
      toastSuccess('Student added successfully');
    } else {
      toastError('Failed to add student');
    }
  };

  useEffect(() => {
    getStudents();
  }, [examData, reload]);

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
    >
      <DialogTitle>Add student to exam</DialogTitle>
      {!loading ? (
        <DialogContent>
          <Paper
            style={{
              marginBottom: '20px',
            }}
            elevation={0}
          >
            <FormControl variant="filled" size="small">
              <Select
                labelId="add-student"
                id="add-student"
                value={student}
                variant="outlined"
                onChange={(e) => setStudent(e.target.value)}
                size="small"
                style={{
                  minWidth: '150px',
                  marginRight: '10px',
                }}
              >
                {students.map((studentItem) => (
                  <MenuItem
                    value={studentItem.email}
                  >
                    {`${studentItem.name} ${studentItem.firstname}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              variant="contained"
              color="primary"
              disableElevation
              onClick={addStudentToExam}
              // size="small"
            >
              Add student
            </Button>
          </Paper>
          <MaterialTable
            title="Students in exam"
            data={studentsInExam}
            columns={[
              {
                title: 'Nom',
                field: 'name',
              },
              {
                title: 'Prénom',
                field: 'firstname',
              },
              {
                title: 'Email',
                field: 'email',
              },
              {
                title: 'Evaluo id',
                field: 'evaluoId',
              },
            ]}
            actions={[
              {
                icon: 'delete',
                tooltip: 'Supprimer',
                onClick: (event, rowData) => {
                  deleteStudentFromExam(rowData.evaluoId);
                },
              },
            ]}
          />
        </DialogContent>
      )
        : <Loading />}
    </Dialog>
  );
};

export default AddStudent;
